<form [formGroup]="form">
  <div class="flex-row min-w-64 mt-5">
    <mat-checkbox [color]="'primary'" [formControlName]="'auto_send'">
      <span>Automatically send report on schedule</span>
    </mat-checkbox>
  </div>
  @if (form.get('auto_send').value) {
    <div class="flex-row min-w-64 mt-5">
      <mat-form-field class="to w-full">
        <mat-label>Recipients</mat-label>
        <mat-chip-list #recipientChipList aria-label="Tag selection">
          @for (email of recipientEmails; track email) {
            <mat-chip [selectable]="true" [removable]="true" (removed)="removeRecipientEmail(email)">
              {{ email }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          }
          <input
            placeholder="Add email..."
            #tagInput
            [formControl]="recipientTagCtrl"
            [matChipInputFor]="recipientChipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addRecipientEmail($event)"
          />
        </mat-chip-list>
      </mat-form-field>
    </div>
    <div class="flex-row min-w-64">
      <div class="flex flex-row justify-between">
        <mat-form-field class="flex-auto mr-3">
          <mat-label>Scheduled Period</mat-label>
          <mat-select [formControlName]="'scheduled_period'">
            <mat-option [value]="'weekly'">Weekly</mat-option>
            <mat-option [value]="'biweekly'">Bi-weekly</mat-option>
            <mat-option [value]="'monthly'">Monthly</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="flex-auto">
          <mat-label>Scheduled Time</mat-label>
          <mat-select [formControlName]="'scheduled_time_of_day'">
            <mat-option [value]="5">5:00 am</mat-option>
            <mat-option [value]="6">6:00 am</mat-option>
            <mat-option [value]="7">7:00 am</mat-option>
            <mat-option [value]="8">8:00 am</mat-option>
            <mat-option [value]="9">9:00 am</mat-option>
            <mat-option [value]="10">10:00 am</mat-option>
            <mat-option [value]="11">11:00 am</mat-option>
            <mat-option [value]="12">12:00 pm</mat-option>
            <mat-option [value]="13">1:00 pm</mat-option>
            <mat-option [value]="14">2:00 pm</mat-option>
            <mat-option [value]="15">3:00 pm</mat-option>
            <mat-option [value]="16">4:00 pm</mat-option>
            <mat-option [value]="17">5:00 pm</mat-option>
            <mat-option [value]="18">6:00 pm</mat-option>
          </mat-select>
          <mat-hint>* Please note, times are in Central Time Zone (CT).</mat-hint>
        </mat-form-field>
      </div>
      <mat-form-field class="w-full">
        <mat-label>Scheduled Days</mat-label>
        <mat-chip-list [disabled]="!isEditable" multiple>
          @for (day of daysOfWeek; track day) {
            <mat-chip
              [disabled]="!isEditable"
              selectable="true"
              [selected]="dayOfWeekIsSelected(day.id)"
              (click)="toggleDayOfWeek($event, day.id)"
            >
              <span class="unselectableText">{{ day.name }}</span>
            </mat-chip>
          }
        </mat-chip-list>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Attachment Format</mat-label>
        <mat-select [formControlName]="'scheduled_report_format'">
          <mat-option [value]="'pdf'">PDF</mat-option>
          <mat-option [value]="'csv'">CSV</mat-option>
          <mat-option [value]="'both'">Both</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Show Totals As</mat-label>
        <mat-select [formControlName]="'section_total_format'">
          <mat-option [value]="'none'">-- Do Not Show Totals --</mat-option>
          <mat-option [value]="'sum'">Sum</mat-option>
          <mat-option [value]="'avg'">Average</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  }
</form>
